/*jshint esversion: 6 */
import VueRouter from 'vue-router';
import Vue from 'vue';
Vue.use(VueRouter);

const routes=[
    {
        name: 'index',
        path: '/',
        component: () => import('../views/home/index')
    },
    {
        name: 'searchResult',
        path: '/result',
        component: () => import('../views/result/index')
    },
    {
        name: 'chartsIndex',
        path: '/visualization',
        component: () => import('../views/charts/index')
    },
    {
        name:'gisAnalysis',
        path:'/gisAnalysis',
        component: () => import('../views/gisAnalysis/index')
    },
    {
        name: 'bkHome',
        path: '/bk/home',
        component: () => import('@/views/bk/home')
    },
    {
        name:'literature',
        path:'/bk/literature',
        component: () => import('../views/bk/literature')
    },
    {
        name:'bkSearchResult',
        path:'/bk/searchResult',
        component: () => import('../views/bk/searchResult')
    },
    {
        name:'textAnalysis',
        path:'/bk/textAnalysis',
        component: () => import('../views/bk/textAnalysis')
    },
    {
        name:'textAnalysisId',
        path:'/bk/textAnalysis/:id',
        component: () => import('../views/bk/textAnalysis')
    },
    {
        name:'bookDetail',
        path:'/bk/bookDetail/:id',
        component: () => import('../views/bk/bookDetail')
    },
    {
        name:'magazineDetail',
        path:'/bk/magazineDetail/:id?',
        component: () => import('../views/bk/magazineDetail')
    },
    {
        name:'newspaperDetail',
        path:'/bk/newspaperDetail/:id?',
        component: () => import('../views/bk/newspaper')
    },
    {
        name:'newspaperimg',
        path:'/bk/newspaperimg',
        component: () => import('../views/bk/iframe/newspaperimg')
    },
    {
        name:'magazineimg',
        path:'/bk/magazineimg',
        component: () => import('../views/bk/iframe/magazineimg')
    },
    {
        name:'advertisementimg',
        path:'/bk/advertisementimg',
        component: () => import('../views/bk/iframe/advertisementimg')
    },
    {
        name:'iiifview',
        path:'/bk/iiifview',
        component: () => import('../views/bk/iframe/iiifview')
    },
    {
        name:'bkSearchResultEcharts',
        path:'/bk/searchResultCharts',
        component: () => import('../views/bk/searchResultCharts/index')
    },
    {
        name:'brandHomeEcharts',
        path:'/bk/brandHomeEcharts',
        component: () => import('../views/bk/brandResult/charts')
    },
    {
        name:'brandHome',
        path:'/bk/brandHome/:id?',
        component: () => import('../views/bk/brandHome')
    },
    {
        name:'brandResult',
        path:'/bk/brandResult/:id?',
        component: () => import('../views/bk/brandResult')
    },
    {
        name:'brandDetail',
        path:'/bk/brandDetail/:id?',
        component: () => import('../views/bk/brandDetail')
    },
    {
        name:'digitalHeader',
        path:'/digitalHeader',
        component: () => import('../components/resultNav/digitalHeader')
    },
    {
        name:'bkHeader',
        path:'/bk/bkHeader',
        component: () => import('../views/bk/nav2/bkHeader')
    },
    {
        name:'user',
        path:'/user',
        component: () => import('../views/uc/user')
    },
    {
        name:'relation',
        path:'/relation',
        component: () => import('../views/uc/relation')
    },
    {
        name:'relation2',
        path:'/relation2',
        component: () => import('../views/uc/relation2')
    },
    ,
    {
        name:'relation3',
        path:'/relation3',
        component: () => import('../views/uc/relation3')
    }
]

export default new VueRouter({
    mode :"history", // 除去#号
    // base: "/hisweb", // base: "/hisweb",
    routes,
})
